//Since the map will be laoded and displayed on client side
'use client';

import { APIProvider } from '@vis.gl/react-google-maps';
import { ReactNode } from 'react';

// Define a function component called MapProvider that takes a children prop
export function MapProvider({ children }: { children: ReactNode }) {
  return <APIProvider apiKey={process.env.NEXT_PUBLIC_GG_MAP_KEY || ''}>{children}</APIProvider>;
}
